<!-- 属性配置添加/修改弹窗 -->
<template>
  <el-dialog title="参数名管理" :visible.sync="dialogVisible" width="550px" @open="open" @closed="handleClose">
    <el-form :model="form" ref="form" label-width="100px">
      <el-form-item label="属性名：" prop="name">
        <el-input v-model="form.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="属性号：" prop="id">
        <el-input v-model="form.id" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="属性排序：" prop="sort">
        <el-input v-model="form.sort" placeholder=""></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { add, edit } from "../api/attr";
export default {
  name: "attrOper",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      auth: null,
      dialogVisible: this.visible,
      form: {
        name: "",
        id: "",
        sort: "",
      },
    };
  },
  methods: {
    open() {
      if (JSON.stringify(this.current != "{}")) {
        this.form.name = this.current.name;
        this.form.id = this.current.attr;
        this.form.sort = this.current.morder;
      }
    },
    submit() {
      if (JSON.stringify(this.current) == "{}") {
        add({
          attrName: this.form.name,
          attrNum: this.form.id,
          attrMorder: this.form.sort,
          user_name: this.auth.user_name,
        }).then((data) => {
          if (data.data.code == 100000) {
            this.$message.success(data.data.msg);
            this.dialogVisible = false;
            this.$emit("refresh");
          } else {
            this.$message.error(data.data.msg);
          }
        });
      } else {
        edit({
          id: this.current.id,
          attrName: this.form.name,
          attrNum: this.form.id,
          attrMorder: this.form.sort,
          user_name: this.auth.user_name,
        }).then((data) => {
          if (data.data.code == 100000) {
            this.$message.success(data.data.msg);
            this.dialogVisible = false;
            this.$emit("refresh");
          } else {
            this.$message.error(data.data.msg);
          }
        });
      }
    },
    handleClose() {
      this.$refs.form.resetFields();
    },
  },
  watch: {
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
    visible(val) {
      this.dialogVisible = val;
    },
  },
  mounted() {
    this.auth = JSON.parse(sessionStorage.getItem("auth"));
  },
};
</script>
<style lang="scss" scoped></style>
